// OWNER: platform module. Route objects relative to /w/:wsId, spread into the router by src/app/router.tsx.
// Each screen is its own lazy chunk; sub-areas live in ./home, ./notifications, ./rules, ./help, ./billing,
// ./analytics, ./data, ./executor, ./admin and ./offline.
import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  { index: true, lazy: async () => ({ Component: (await import('./home/HomePage')).HomePage }) },
  { path: 'this-week', lazy: async () => ({ Component: (await import('./notifications/ThisWeekPage')).ThisWeekPage }) },
  { path: 'more/notifications', lazy: async () => ({ Component: (await import('./notifications/NotificationsPage')).NotificationsPage }) },
  { path: 'more/rules', lazy: async () => ({ Component: (await import('./rules/RulesPage')).RulesPage }) },
  { path: 'more/explanations', lazy: async () => ({ Component: (await import('./rules/ExplanationsPage')).ExplanationsPage }) },
  { path: 'more/subscription', lazy: async () => ({ Component: (await import('./billing/SubscriptionPage')).SubscriptionPage }) },
  { path: 'more/data', lazy: async () => ({ Component: (await import('./data/DataPage')).DataPage }) },
  { path: 'more/executor', lazy: async () => ({ Component: (await import('./executor/ExecutorPage')).ExecutorPage }) },
  { path: 'more/help', lazy: async () => ({ Component: (await import('./help/HelpPage')).HelpPage }) },
];

/**
 * Top-level admin routes, mounted at /admin (outside any workspace) behind a platform-admin guard.
 * Paths are relative to /admin.
 */
export const adminRoutes: RouteObject[] = [
  { index: true, lazy: async () => ({ Component: (await import('./admin/AdminIndexPage')).AdminIndexPage }) },
  { path: 'rules', lazy: async () => ({ Component: (await import('./rules/AdminRulesPage')).AdminRulesPage }) },
  { path: 'analytics', lazy: async () => ({ Component: (await import('./analytics/AdminAnalyticsPage')).AdminAnalyticsPage }) },
  { path: 'billing', lazy: async () => ({ Component: (await import('./billing/AdminBillingPage')).AdminBillingPage }) },
];
